import { render, staticRenderFns } from "./abroad-contact-duns.vue?vue&type=template&id=5777f22c&scoped=true&"
import script from "./abroad-contact-duns.vue?vue&type=script&lang=js&"
export * from "./abroad-contact-duns.vue?vue&type=script&lang=js&"
import style0 from "./abroad-contact-duns.vue?vue&type=style&index=0&id=5777f22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777f22c",
  null
  
)

export default component.exports